export default "<h1>Something Wrong</h1>\n";